module.exports = __webpack_public_path__ + "static/img/图层 46.ed49cd0c.png";